import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { StarRatingCmp } from './star-rating';


export class StarRatingModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: StarRatingModule, providers: []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule
  ],
  exports: [
    StarRatingCmp
  ],
  declarations: [
    StarRatingCmp
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
